var render = function render(){var _vm=this,_c=_vm._self._c;return _c('carousel',_vm._b({ref:"carousel"},'carousel',_vm.settings,false),_vm._l((_vm.advertisings),function(advertising){return _c('slide',{key:advertising.id},[_c('div',{staticClass:"carousel-body",domProps:{"innerHTML":_vm._s(advertising.transContent)}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }